/**
 * 广告位定义
 */

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 展现形式
 */
class DisplayForm extends UltMeta {
    FIXED_SINGLE_IMAGE = new Meta(1, "固定单图");
    MULTI_IMAGE_ROTATION = new Meta(2, "多图轮播");
}

export const DISPLAY_FORM = new DisplayForm();
/**
 * 轮播间隔
 */
class RotationInterval extends UltMeta {
    THREE_SECONDS = new Meta(1, "3 秒");
    FIVE_SECONDS = new Meta(2, "5 秒");
}
export const ROTATION_INTERVAl = new RotationInterval();

/** 广告小程序 */
class BannerType extends UltMeta {
    PRODUCT = new Meta(1, "商品");
    PRODUCT_TYPE = new Meta(2, "砂价");
    WHARF = new Meta(3, "运价");
    AD_PAGE = new Meta(4, "广告页");
    INFORMATION = new Meta(5, "资讯");
    FEATURE = new Meta(6, "功能页");
}
export const BANNER_TYPE = new BannerType();

/** 货主功能页枚举 */
class OwnerFeaturePageType extends UltMeta {
    SAND_GRAVEL_INDEX = new Meta("1", "砂石指数首页", "/page/index/index?indexPageActive=砂石指数");
    FREIGHT_INDEX = new Meta("2", "运价指数首页", "/page/index/index?indexPageActive=运价指数");
    INFORMATION = new Meta("3", "资讯首页", "/page/index/index?indexPageActive=最新资讯");
    CHECK_SHIP = new Meta("4", "查船页", "/page/comSubpackage/webview/webview?token=true&mapPageUrl=true");
    CHECK_CAR = new Meta("5", "查车页", "/page/comSubpackage/webview/webview?token=true&truckLocationPageUrl=true");
    FIND_BOAT = new Meta(
        "6",
        "找船页",
        "/page/business/customer/shipOrder/myShipDemand/myShipDemandAdd/myShipDemandAdd?token=true"
    );
    AI = new Meta("7", "ai聊天页", "/page/assistant/assistant?token=true");
    PRODUCT_LIST = new Meta("8", "商品列表页", "/page/comSubpackage/product/index");
    MEMBER = new Meta("9", "会员页", "/page/vip/membership/membership?token=true");
    DATA_DASHBOARD = new Meta("10", "数据看板页", "/page/index/dashboard/dashboard?token=true");
    AUTHENTICATION = new Meta("11", "认证页", "/page/setting/contact/contact?token=true");
    ABOUT_US = new Meta("12", "关于我们", "/page/setting/article/article?title=关于我们&type=1");
}
export const OWNER_FEATURE_PAGE_TYPE = new OwnerFeaturePageType();

/** 承运商功能页枚举 */
class CarriersFeaturePageType extends UltMeta {
    SAND_GRAVEL_INDEX = new Meta("1", "砂石指数首页", "/pages/index/index?indexPageActive='砂石指数'");
    FREIGHT_INDEX = new Meta("2", "运价指数首页", "/pages/index/index?indexPageActive='运价指数'");
    INFORMATION = new Meta("3", "资讯首页", "/pages/index/index?indexPageActive='最新资讯'");
    CHECK_SHIP = new Meta("4", "查船页", "/pages/webview/webview?mapPageUrl=true&token=true`");
    CHECK_CAR = new Meta("5", "查车页", "/pages/webview/webview?truckLocationPageUrl=true&token=true`");
    SHIPPING_NEED_LIST = new Meta("6", "船运需求列表", "/pages/shipRequire/shipRequire?token=true");
    TRANSPORT_ORDER = new Meta("7", "运单页", "/pages/transportOrderShip/transportOrderShip?token=true&isTab=true");
    VIEW_VESSEL_MONITORING = new Meta("8", "查看船舶监控", "/pages/shipMonitorShare/list/index?token=true");
    CERTIFIED_VESSELS = new Meta("9", "认证船舶页面", "/pages/shipping/auth/create/create?token=true");
    MEMBER = new Meta("10", "会员页", "/pages/vip/membership/membership?token=true");
    AUTHENTICATION = new Meta("11", "认证页", "/pages/setting/contact/contact?token=true");
    ABOUT_US = new Meta("12", "关于我们", "/pages/setting/article/article?title=关于我们&type=1");
    ALWAYS_RUN_ROUTE = new Meta("13", "常跑航线", "/pages/setting/frequentFlightRoutes/frequentFlightRoutes?token=true");
}
export const CARRIERS_FEATURE_PAGE_TYPE = new CarriersFeaturePageType();
